import {
  Drawer,
  Button,
  Grid,
  Card,
  Box,
  Divider,
  IconButton,
  Typography,
  Tooltip,
  AlertColor,
} from '@mui/material';
import { styled } from '@mui/system';
import React, {
  ChangeEvent,
  FC,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import * as yup from 'yup';
import { Formik, FormikErrors, FormikProps } from 'formik';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import MediumTypography from '../../components/formlib/MediumTypography';
import Textinput from '../../components/formlib/Textinput';
import dayjs, { Dayjs } from 'dayjs';
import SmallTypography from '../../components/formlib/SmallTypography';
import {
  Client,
  SchedulerEventType,
  EditSchedulerEventType,
  SchedulerAttendee,
  SchedulerClient,
  OptionType,
    AttendeeRole,
} from '../../utils/type';
import {
  Employee,
  getAllEmployeeList,
} from '../../services/configApi/employees/employeeServices';
import MultiSelectAutocompleteSearch from '../../components/formlib/MultiSelectAutocompleteSearch';
import {
  STORAGE_USERNAME_KEY,
  STORAGE_USER_ID_KEY,
} from '../../services/Constant';
import { ReactComponent as User } from '../../assets/images/User.svg';
import { ReactComponent as MapPin } from '../../assets/images/map_pin.svg';
import { ReactComponent as AlignLeft } from '../../assets/images/align_left.svg';
import { ReactComponent as Menu } from '../../assets/images/menu.svg';
import { ReactComponent as Clock } from '../../assets/images/clock.svg';
import { ReactComponent as DeleteIcon } from '../../assets/images/DeleteIcon.svg';
import { ReactComponent as Closegray } from '../../assets/images/x.svg';
import { ReactComponent as Calender } from '../../assets/images/Calendar.svg';
import { FormattedMessage, useIntl } from 'react-intl';
import DeleteSchedulerEventModal from './DeleteSchedulerEventModal';
import {
  editAppointment,
  checkAvailability,
  getOwnerEventDetailsById,
} from '../../services/schedulerEventsApi';
import UnavailabilityCheckModal from './UnavailabilityCheckModal';
import {
  ApiError,
  ApiMessage,
  isCustomError,
} from '../../services/ApiResponseHandler';
import ModalPopup from '../../components/formlib/ModalPopup';
import _, { debounce } from 'lodash';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import AppTimePicker from '../../components/formlib/AppTimePicker';
import moment from 'moment';
import {
  appointmentTypes,
  appointmentTypesForMultiClients,
} from './schedulerUtils';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import { checkPermissionForFeature } from '../../utils/checkPermission';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import CustomRadioButton from '../../components/formlib/CustomRadioButton';
// import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';
import EditConfirmationModalForRecurring from './EditConfirmationModalForRecurring';
import { getAllClients } from '../../services/configApi/Clients';

dayjs.extend(utc);
dayjs.extend(timezone);
export const InterpreterOptions: OptionType[] = [
  {
    id: 'CLINICIAN',
    label: 'Clinician',
  },
  {
    id: 'INTERPRETER',
    label: 'Interpreter',
  },
  {
    id: 'GROUP_ASSISTANT',
    label: 'Group Assistant',
  },
]
interface EditModelPropType {
  showModal: boolean;
  onModalClose: (
    openFromEdit: boolean,
    toastrVariableFromEdit?: AlertColor,
    toastrMessageFromEdit?: string,
    toastrIdFromEdit?: string,
    toastrDefaultMessageFromEdit?: string,
  ) => void;
  eventId: string;
}

export type DateString = Dayjs | null | string;

export const SubmitButton = styled(Button)`
  background: #00938e;
  font-family: 'Lato-Regular', sans-serif;
  font-style: normal;
  color: #ffffff;
  &:hover {
    background: #00938e;
    color: #ffffff;
  }
`;

export const CancelButton = styled(Button)`
  background: #ffffff;
  font-family: 'Lato-Regular', sans-serif;
  font-style: normal;
  border: 1px solid #97a6a5;
  color: #2a4241;
  &:hover {
    background: #ffffff;
    color: #2a4241;
  }
`;

const drawerWidth = 600;

const validationSchema = yup.object().shape({
  clients: yup.array().of(yup.string()),
  location: yup.string().when('clients', {
    is: (clients: MultiSelectOptioinType[]) => clients && clients.length > 0,
    then: yup.string().required('locationRequiredMessage'),
    otherwise: yup.string(),
  }),
  isManualLocationUpdate: yup.boolean().default(false),
  appointmentType: yup.string().required('apptTypeRequiredMessage'),
  otherDescription: yup.string().when('appointmentType', {
    is: 'appointmentType10',
    then: yup.string().required('BlockingTime.descriptionError').nullable(),
    otherwise: yup.string().nullable(),
  }),
  attendeeList: yup.array().of(
    yup.object().shape({
      attendeeId: yup.string(),
      attendeeName: yup.string().nullable(),
      date: yup.string(),
      startTime: yup.date().required('startTimeRequiredMessage'),
      endTime: yup
        .date()
        .required('endTimeRequiredMessage')
        .test(
          'end-date-not-equal',
          'schedulerEndDateValidationMessage',
          function (value, context) {
            return dayjs(context.parent.startTime).isBefore(dayjs(value));
          },
        ),
      status: yup.string(),
    }),
  ),
  attendees: yup.array().when('clients', (clients, schema) => {
    return schema.min(1, 'AddNewSchedulerEvent.minAttendeeMessage').required();
  }),
  editDate: yup
    .string()
    .required('dateRequiredErrorMessage')
    .test({
      name: 'editDate',
      message: 'datePickerMinDateMaxDateValidate',
      test: function (value) {
        const pickerMin = '01/01/1900';
        const pickerMax = '12/31/2099';
        if (
          dayjs(value).isBefore(pickerMin) ||
          dayjs(value).isAfter(pickerMax)
        ) {
          return this.createError({
            path: this.path,
            message: 'datePickerMinDateMaxDateValidate',
          });
        }
        return true;
      },
    })
    .nullable(),
});

type MultiSelectOptioinType = Employee | Client;
let selectedAttendees: MultiSelectOptioinType[] = [];
let schedulerEventAttendeeList: SchedulerAttendee[] = [];

const EditSchedulerEventModal: FC<EditModelPropType> = ({
  showModal,
  onModalClose,
  eventId,
}) => {
  const rctl = useIntl();
  const loggedInClinicianName = localStorage.getItem(STORAGE_USERNAME_KEY);
  const [schedulerEvent, setSchedulerEvent] = useState<SchedulerEventType>();
  const existingClientList = useRef<string[]>([]);
  const [backupSchedulerEvent, setBackupSchedulerEvent] =
    useState<SchedulerEventType>();
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  // const [showLoader, setShowLoader] = useState<boolean>(true);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [openUpdateModel, setOpenUpdateModel] = useState(false);
  const [openAvailabilityCheckModel, setOpenAvailabilityCheckModel] =
    useState(false);
  const [highlightUnavailableAttendees, setHighlightUnavailableAttendees] =
    useState(false);
  const [unavailableAttendees, setUnavailableAttendees] = useState<string[]>(
    [],
  );
  const [appStartDate, setAppStartDate] = useState<DateString>(null);
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [editAppointmentValues, setEditAppointmentValues] =
    useState<EditSchedulerEventType>();
  const [openModal, setOpenModal] = useState(false);
  const [assessments, setAssessments] = useState('');
  const [commonDate, setCommonDate] = useState<string | null>(null);
  const [backupCommonDate, setBackupCommonDate] = useState<string | null>(null);
  const [backupSelectedCommonDate, setBackupSelectedCommonDate] = useState<
    string | null
  >(null);
  const formRef = React.useRef<FormikProps<EditSchedulerEventType>>(null);
  const [originalAddress, setOriginalAddress] = useState<string | null>(null);
  const [isAttendee, setIsAttendee] = useState(false);
  const [clients, setClients] = useState<Client[]>([]);
  const [clientSearchText, setClientSearchText] = useState<string>('');
  const [recurringType, setRecurringType] = useState<
    'this_appointment' | 'following_appointments'
  >('this_appointment');

  useEffect(() => {
    if (schedulerEvent?.appointmentType) {
      handleClientSearchChange(
        clientSearchText,
        schedulerEvent?.clients?.map((client) => client.clientId) ?? [],
      );
    }
  }, [clientSearchText, schedulerEvent?.clients]);

  const handleClientSearchChange = useCallback(
    debounce((value: string, clientIds: string[] | null) => {
      getAllClients(true, value, clientIds ? [...clientIds] : null)
        .then((response) => setClients(response))
        .catch(() => {});
    }, 500),
    [],
  );

  const clearForm = () => {
    selectedAttendees = backupSchedulerEvent?.attendees as Employee[];
    formRef.current?.setValues(formRef.current?.initialValues);
    // getSchedulerEventDetails();
    setOpenModal(false);
  };

  useEffect(() => {
    if (commonDate) {
      const updatedAttendeeList =
        formRef.current &&
        formRef.current.values.attendeeList.map((attendee) => ({
          ...attendee,
          date: commonDate,
          status: attendee.status === 'CREATE' ? 'CREATE' : 'UPDATE',
        }));
      if (formRef.current)
        formRef.current.setFieldValue('attendeeList', updatedAttendeeList);
    }
  }, [commonDate]);

  useEffect(() => {
    return () => {
      clearForm();
      selectedAttendees = [];
    };
  }, []);

  const canEventDelete = () => {
    const userId = localStorage.getItem(STORAGE_USER_ID_KEY);
    if (schedulerEvent && userId !== null) {
      if (userId === schedulerEvent.owner.id) {
        // He is the owner
        let canDelete: boolean = true;
        schedulerEvent.attendeeList.forEach((attendee) => {
          if (!attendee.allowUpdateDeleteActions) {
            canDelete = false;
          }
        });
        return canDelete;
      } else {
        // He is the attendee
        schedulerEvent.attendeeList.forEach((attendee) => {
          if (attendee.attendeeId === userId) {
            let canDelete: boolean = true;
            if (!attendee.allowUpdateDeleteActions) {
              canDelete = false;
            }
            return canDelete;
          }
          // if (
          //   attendee.attendeeId === userId &&
          //   !attendee.allowUpdateDeleteActions
          // ) {
          //   canDelete = false;
          // }
        });
      }
    }
  };

  const getAttendeeList = (event: SchedulerEventType) => {
    getAllEmployeeList(
      dayjs.utc(event.start).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
    )
      .then((response) => {
        event.attendeeList.forEach((attendee) => {
          const employee = response.find(
            (emp) => emp.id === attendee.attendeeId,
          );
          if (employee) {
            attendee.attendeeName = `${employee.firstName} ${employee.lastName}`;
          }
        });
        if (event.location) {
          setOriginalAddress(event.location);
        }
        setAppStartDate(event.start);
        setSchedulerEvent(event);
        const copyEvent = JSON.parse(JSON.stringify(event));
        setBackupSchedulerEvent(copyEvent);
        schedulerEventAttendeeList = [...event.attendeeList];
        setEmployees(response);
        toggleLoader(false);
      })
      .catch(() => {});
  };

  const getDisabledState = (
    appointmentType: string,
    apptClients: Client[] | undefined,
  ) => {
    if (!appointmentTypesForMultiClients.includes(appointmentType)) {
      if (
        apptClients !== undefined &&
        apptClients.length > 0 &&
        apptClients[0].allowDelete === false
      ) {
        return true;
      }
      return false;
    }
    return false;
  };

  const updateEvent = useCallback(
    debounce((values: EditSchedulerEventType, eventType: string) => {
      toggleLoader(true);
      formHandleSubmit(values, eventType);
    }, 500),
    [originalAddress],
  );

  const formHandleSubmit = (
    values: EditSchedulerEventType,
    updateType: string,
  ) => {
    setHighlightUnavailableAttendees(false);
    setUnavailableAttendees([]);
    setEditAppointmentValues(values);

    values.attendeeList.forEach((attendee) => {
      const date = dayjs(attendee.date).format('YYYY-MM-DD');
      const startTime = dayjs(attendee.startTime).format('HH:mm:ss');
      const endTime = dayjs(attendee.endTime).format('HH:mm:ss');
      const timeZOne = dayjs(attendee.date).format('Z');

      const newStartTime = dayjs.utc(`${date} ${startTime}${timeZOne}`);
      const newEndTime = dayjs.utc(`${date} ${endTime}${timeZOne}`);

      if (newEndTime.isBefore(newStartTime)) {
        attendee.startTime = newStartTime.format();
        attendee.endTime = newEndTime.add(1, 'day').format();
      } else {
        attendee.startTime = newStartTime.format();
        attendee.endTime = newEndTime.format();
      }
    });

    const existingClientSet = new Set(existingClientList.current);
    const currentClientSet = new Set(values.clients);

    const newClientList: SchedulerClient[] = [
      // Handle existing clients (CLINICIAN if still selected, DELETE if removed)
      ...existingClientList.current.map(
        (clientId) =>
          ({
            clientId,
            status: currentClientSet.has(clientId) ? 'NONE' : 'DELETE',
          } as SchedulerClient),
      ),
      // Handle newly added clients (CREATE)
      ...values.clients
        .filter((clientId) => !existingClientSet.has(clientId))
        .map(
          (clientId) =>
            ({
              clientId,
              status: 'CREATE',
            } as SchedulerClient),
        ),
    ];
    values.clientList = newClientList;

    if (originalAddress) {
      values.isManualLocationUpdate = originalAddress !== values.location;
    } else {
      values.isManualLocationUpdate = false;
    }

    values.attendeeList.forEach((attendee) => {
      if (attendee.status !== 'UPDATE' || !backupSchedulerEvent) {
        return; // Early return for cleaner flow
      }

      const backupAttendee = backupSchedulerEvent.attendeeList.find(
        (backup) => backup.attendeeId === attendee.attendeeId,
      );

      if (backupAttendee && !hasAttendeeChanged(attendee, backupAttendee)) {
        attendee.status = 'NONE';
      }
    });

    if (values.attendees != undefined && values.attendees.length != 0) {
      checkAvailability(values, eventId)
        .then((response) => {
          const attendees: string[] = [];
          if (response.attendeeList !== null) {
            response.attendeeList.forEach((attendee) => {
              if (
                attendee.unavailableStatus &&
                attendee.unavailableStatus !== null &&
                attendee.unavailableStatus === true
              ) {
                attendees.push(attendee.attendeeId);
              }
            });
          }
          if (attendees.length != 0) {
            setOpenAvailabilityCheckModel(true);
            setUnavailableAttendees(attendees);
            toggleLoader(false);
          } else {
            saveAppointment(values, updateType);
          }
        })
        .catch((error) => {
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            onModalClose(
              true,
              'error',
              apiError.message,
              rctl.formatMessage({ id: apiError.id }),
              undefined,
            );
          } else {
            const response = error as ApiMessage;
            onModalClose(
              true,
              'error',
              response.message,
              'failedApiMsg',
              undefined,
            );
          }
          toggleLoader(false);
        });
    } else {
      saveAppointment(values, updateType);
    }
  };

  const hasAttendeeChanged = (
    current: SchedulerAttendee,
    backup: SchedulerAttendee,
  ): boolean => {
    return (
      backup.startTime !== current.startTime ||
      backup.endTime !== current.endTime ||
       backup.attendeeRole !== current.attendeeRole
    );
  };

  const saveAppointment = (
    values: EditSchedulerEventType,
    updateType: string,
  ) => {
    toggleLoader(true);
    setHighlightUnavailableAttendees(false);
    setUnavailableAttendees([]);

    editAppointment(values, updateType)
      .then(() => {
        toggleLoader(false);
        onModalClose(
          true,
          'success',
          undefined,
          'EditNewSchedulerEvent.successMessage',
          'Appointment updated successfully',
        );
      })
      .catch((error) => {
        toggleLoader(false);
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          onModalClose(
            true,
            'error',
            apiError.message,
            rctl.formatMessage({ id: apiError.id }),
            undefined,
          );
        } else if (error.code === 1107) {
          onModalClose(
            true,
            'error',
            error.message,
            'createAppointmentInactiveClientError',
            undefined,
          );
        } else if (error.code === 1116) {
          onModalClose(
            true,
            'error',
            error.message,
            'createAppointmentActivitySheetSubmittedErrorMessage',
            undefined,
          );
        } else if (error.code === 1119) {
          onModalClose(
            true,
            'error',
            error.message,
            'updateAppointmentAttendeeAsInterpreterErrorMessage',
            undefined,
          );
        } else if (error.code === 1136) {
          onModalClose(
            true,
            'error',
            error.message,
            'createAppointmentAttendeeInactiveErrorMessage',
            undefined,
          );
        } else if (error.code === 1137) {
          onModalClose(
            true,
            'error',
            error.message,
            'employeeIdCannotBeEmpty',
            undefined,
          );
        } else if (error.code === 1138) {
          onModalClose(
            true,
            'error',
            error.message,
            'onlyFutureEventsCanBeDeleted',
            undefined,
          );
        } else if (error.code === 1139) {
          onModalClose(
            true,
            'error',
            error.message,
            'apptProgressNoteSignedMessage',
            undefined,
          );
        } else if (error.code === 1140) {
          onModalClose(
            true,
            'error',
            error.message,
            'appointmentApprovedMessage',
            undefined,
          );
        } else if (error.code === 1115) {
          onModalClose(
            true,
            'error',
            error.message,
            'appointmentDoesNotExitsOrDeleted',
            undefined,
          );
        } else if (error.code === 1163) {
          onModalClose(
            true,
            'error',
            error.message,
            'appointmentStartDateCannotBePriorToReferralBeginDate',
            undefined,
          );
        } else {
          const response = error as ApiMessage;
          onModalClose(
            true,
            'error',
            response.message,
            'failedApiMsg',
            undefined,
          );
        }
      });
  };

  const showDelete = () => setOpenDeleteModel(true);

  const closeDeleteModal = (
    openFromDelete: boolean,
    toastrVariableFromDelete?: AlertColor,
    toastrMessageFromDelete?: string,
    toastrIdFromEdit?: string,
    toastrDefaultMessageFromDelete?: string,
  ) => {
    onModalClose(
      openFromDelete,
      toastrVariableFromDelete,
      toastrMessageFromDelete,
      toastrIdFromEdit,
      toastrDefaultMessageFromDelete,
    );
    setOpenDeleteModel(false);
  };

  const prepareOwnerName = () => {
    if (schedulerEvent) {
      const owner = schedulerEvent.owner;
      return (
        (owner.firstName ?? owner.firstName) +
        ' ' +
        (owner.lastName ?? owner.lastName)
      );
    }
    return '';
  };

  const getSchedulerEventDetails = () => {
    const userId = localStorage.getItem(STORAGE_USER_ID_KEY);
    if (userId === null) {
      return;
    }
    toggleLoader(true);
    getOwnerEventDetailsById(eventId, userId)
      .then((data) => {
        existingClientList.current =
          data?.clients?.map((client) => client.clientId) ?? [];
        if (data?.owner.id === localStorage.getItem(STORAGE_USER_ID_KEY)) {
          setIsAttendee(true);
        } else if (data?.attendees != undefined) {
          data.attendees.forEach((attendee) => {
            if (attendee.id === localStorage.getItem(STORAGE_USER_ID_KEY)) {
              setIsAttendee(true);
            }
          });
        }

        const dateTime = data.attendeeList[0].startTime;
        const date = dayjs(dateTime).format('YYYY-MM-DD');
        const backup = dayjs(dateTime).format('MM/DD/YYYY');
        setBackupCommonDate(backup);
        setBackupSelectedCommonDate(backup);
        setCommonDate(date);
        setAssessments(
          data.appointmentType == 'appointmentType2' ||
            data.appointmentType == 'appointmentType3'
            ? 'appointmentTypeCombined'
            : '',
        );
        const matchingClients: Client[] = [];
        data.clients?.forEach((client) => {
          clients.forEach((c) => {
            if (c.clientId === client.clientId) {
              matchingClients.push(client);
            }
          });
        });
        const allowDelete = data.attendeeList.find(
          (attendee) => !attendee.allowUpdateDeleteActions,
        );
        if (allowDelete) {
          data.allowUpdateDeleteActions = false;
        }
        data.attendeeList.forEach((attendee) => {
          attendee.date = moment(attendee.startTime, 'YYYY-MM-DDTHH:mm:ssZ')
            .utc()
            .local()
            .format();
          attendee.status = 'NONE';
          return attendee;
        });
        if (data.attendees) {
          data.attendees.forEach((attendee) => {
            const att = data.attendeeList.find(
              (a) => a.attendeeId === attendee.id,
            );
            if (att) {
              attendee.allowDelete = att.allowUpdateDeleteActions;
            }
            return attendee;
          });
        }
        selectedAttendees = data.attendees as Employee[];
        if (matchingClients.length > 0) {
          const updatedData: SchedulerEventType = {
            ...data,
            clients: matchingClients,
          };
          // setSchedulerEvent(updatedData);
          getAttendeeList(updatedData);
        } else {
          getAttendeeList(data);
        }
      })
      .catch((error) => {
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          onModalClose(
            true,
            'error',
            apiError.message,
            rctl.formatMessage({ id: apiError.id }),
            undefined,
          );
        } else {
          const response = error as ApiMessage;
          toggleLoader(false);
          onModalClose(
            true,
            'error',
            response.message,
            'failedApiMsg',
            undefined,
          );
        }
      });
  };

  useEffect(() => {
    getSchedulerEventDetails();
  }, []);

  const closeUnavailabilityModal = (
    justCloseWithoutAnySelection: boolean,
    proceedWithUnavailabilites: boolean,
  ) => {
    if (!justCloseWithoutAnySelection) {
      if (proceedWithUnavailabilites && editAppointmentValues) {
        saveAppointment(editAppointmentValues, recurringType);
      } else {
        setHighlightUnavailableAttendees(true);
      }
    }
    setOpenAvailabilityCheckModel(false);
  };

  const getClientAddress = useCallback((client: Client): string => {
    const addressParts = [
      client.eStreet,
      client.eAddress2,
      client.eCity,
      client.eState,
      client.eZipCode ?? '',
    ]
      .filter(Boolean)
      .join(', ');
    return addressParts;
  }, []);

  const getMinimumDate = () => {
    const selectedDate = dayjs(commonDate);
    return dayjs(selectedDate).date(selectedDate.date() - selectedDate.day());
  };

  return (
    <>
      <Divider sx={{ bgcolor: '#CFDEDE' }} />
      {editAppointmentValues && (
        <UnavailabilityCheckModal
          openAvailabilityCheckModel={openAvailabilityCheckModel}
          closeUnavailabilityModal={closeUnavailabilityModal}
        ></UnavailabilityCheckModal>
      )}
      <ModalPopup
        open={openModal}
        description="formUnsavedChangesMessage"
        onCancel={() => setOpenModal(false)}
        onOk={() => {
          clearForm();
        }}
        labelId1="Clientpage.cancelbtn"
        negativeActionLabel="Cancel"
        labelId2="Clientpage.Okbtn"
        positiveActionLabel="Ok"
      />
      <Drawer
        sx={{
          width: drawerWidth,
          paddingInline: '24px',
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
          opacity: 1,
          pointerEvents: 'auto',
        }}
        anchor={'right'}
        open={showModal}
        onClose={() => {
          onModalClose(false, 'success', undefined, undefined, undefined);
        }}
      >
        {schedulerEvent && (
          <>
            {openDeleteModel && (
              <DeleteSchedulerEventModal
                schedulerEvent={schedulerEvent}
                openDeleteEventModel={openDeleteModel}
                closeDeleteModal={closeDeleteModal}
              />
            )}
            <EditConfirmationModalForRecurring
              showModal={openUpdateModel}
              closeModal={(value: string | null) => {
                if (value) {
                  const values = formRef.current?.values;
                  if (values) {
                    updateEvent(
                      JSON.parse(JSON.stringify(values)),
                      value === 'this'
                        ? 'this_appointment'
                        : 'following_appointments',
                    );
                  }
                }
                setRecurringType(
                  value === 'this'
                    ? 'this_appointment'
                    : 'following_appointments',
                );
                setOpenUpdateModel(false);
              }}
            />
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                bgcolor: '#E7F0F0',
                padding: '0px 0px 0px 0px !important',
                backgroundColor: '#fff',
              }}
            >
              <Card
                sx={{
                  padding: '24px',
                  my: '0px',
                  ml: '0px',
                  mt: '0px',
                  boxShadow: 'none',
                }}
              >
                <Formik
                  innerRef={formRef}
                  initialValues={{
                    location: schedulerEvent.location ?? '',
                    otherDescription: schedulerEvent.otherDescription,
                    description: schedulerEvent.description ?? '',
                    isManualLocationUpdate: false,
                    // start: dayjs(schedulerEvent.start),
                    // end: dayjs(schedulerEvent.end),
                    attendeeList: schedulerEvent.attendeeList,
                    appointmentType: schedulerEvent.appointmentType ?? '',
                    frequency: schedulerEvent.frequency ?? '',
                    recurringEvent: schedulerEvent.recurringEvent,
                    clients:
                      schedulerEvent.clients != undefined &&
                      schedulerEvent.clients.length != 0
                        ? schedulerEvent.clients.map(
                            (client) => client.clientId,
                          )
                        : [],
                    clientList: [],
                    attendees:
                      schedulerEvent.attendees != undefined &&
                      schedulerEvent.attendees.length != 0
                        ? schedulerEvent.attendees.map(
                            (clinician) => clinician.id,
                          )
                        : [],
                    owner: schedulerEvent.owner?.id,
                    recurringId: schedulerEvent.recurringId,
                    commonAppointmentId: schedulerEvent.commonAppointmentId,
                    editDate:
                      schedulerEvent.attendeeList.length > 0
                        ? schedulerEvent.attendeeList[0].date
                        : null,
                  }}
                  validationSchema={validationSchema}
                  onSubmit={(values) => {
                    const hasInterpreter = values.attendeeList.some((att) => {
                      return att.attendeeRole !== AttendeeRole.CLINICIAN

                    });
                    if (
                      schedulerEvent.occurrences &&
                      schedulerEvent.occurrences.length > 1 &&
                      backupCommonDate !== backupSelectedCommonDate
                    ) {
                      onModalClose(
                        true,
                        'error',
                        undefined,
                        'cannotUpdateDateForReccuringEvents',
                        'Cannot update date for recurring events.',
                      );
                    } else if (hasInterpreter && values.clients.length === 0) {
                      onModalClose(
                        true,
                        'error',
                        undefined,
                        'noClientsInterpreterValidationMessage',
                        'Client(s) field cannot be empty when an interpreter is added',
                      );
                    } else if (
                      schedulerEvent.occurrences &&
                      schedulerEvent.occurrences.length > 1 &&
                      !dayjs(schedulerEvent.end).isSame(
                        dayjs(
                          schedulerEvent.occurrences[
                            schedulerEvent.occurrences.length - 1
                          ].end,
                        ),
                      )
                    ) {
                      setOpenUpdateModel(true);
                    } else {
                      updateEvent(
                        JSON.parse(JSON.stringify(values)),
                        recurringType,
                      );
                    }
                  }}
                >
                  {({
                    setFieldValue,
                    handleSubmit,
                    initialValues,
                    values,
                    errors,
                    touched,
                  }) => (
                    <Grid container style={{ gap: 16 }}>
                      <Grid container direction="row" alignItems="center">
                        <Grid item xs={10.4}>
                          <Typography
                            gutterBottom
                            component="div"
                            style={{
                              color: '#2A4241',
                              fontSize: '16px',
                              fontWeight: '600',
                              lineHeight: '36px',
                              fontFamily: 'Lato-Bold',
                            }}
                          >
                            <FormattedMessage
                              id="AddNewSchedulerEvent.EditAppointmentTitle"
                              defaultMessage="Edit an Appointment"
                            />
                          </Typography>{' '}
                        </Grid>

                        <Grid item xs={0.8}>
                          {(checkPermissionForFeature(
                            'backend.appointment',
                            'deletePermission',
                          ) ||
                            isAttendee ||
                            canEventDelete()) && (
                            <Tooltip title="Delete">
                              <IconButton onClick={showDelete}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Grid>

                        <Grid item xs={0.8} textAlign={'right'}>
                          <IconButton
                            onClick={() => {
                              onModalClose(
                                false,
                                'success',
                                undefined,
                                undefined,
                                undefined,
                              );
                            }}
                          >
                            <Closegray />
                          </IconButton>
                        </Grid>
                      </Grid>

                      <Grid container direction="row" alignItems="center">
                        <Grid item xs={1} className="svgIcon">
                          <Menu />
                        </Grid>
                        <Grid item xs={11}>
                          <DropdownComponent
                            disabled={
                              true
                              // (schedulerEvent.occurrences != undefined &&
                              //   schedulerEvent.occurrences != null &&
                              //   schedulerEvent.occurrences.length != 0) ||
                              // schedulerEvent.allowUpdateDeleteActions === false
                            }
                            labelid="AddNewSchedulerEvent.appointmentType"
                            defaultlabelid="Appointment type"
                            name={'appointmentType'}
                            handleChange={(value: string) => {
                              setFieldValue('appointmentType', value);
                              setFieldValue('clients', []);
                              setFieldValue('description', '');
                              setFieldValue('location', '');
                              const updatedSchedulerEvent = {
                                ...schedulerEvent,
                                clients: [],
                              };
                              setSchedulerEvent(updatedSchedulerEvent);
                            }}
                            value={
                              assessments !== ''
                                ? assessments
                                : values.appointmentType
                            }
                            names={appointmentTypes}
                          />
                          {errors.appointmentType &&
                            touched.appointmentType && (
                              <SmallTypography
                                sxProps={{ color: 'red' }}
                                labelId={errors.appointmentType}
                              />
                            )}
                          {values.appointmentType == 'appointmentType10' && (
                            <Textinput
                              className="mt-lg"
                              labelid="description"
                              Required
                              defaultlabelid="Description"
                              inputProps={{ maxLength: 30 }}
                              Value={values.otherDescription}
                              handlechange={(value) =>
                                setFieldValue('otherDescription', value)
                              }
                            />
                          )}
                          {errors.otherDescription &&
                            touched.otherDescription && (
                              <MediumTypography
                                className="errorText-md"
                                labelid={errors.otherDescription}
                                defaultlabel={'Description is required'}
                              />
                            )}
                        </Grid>
                      </Grid>

                      {assessments == 'appointmentTypeCombined' && (
                        <Grid container direction="row" alignItems="center">
                          <Grid item xs={1} className="svgIcon"></Grid>
                          <Grid item xs={11}>
                            <CustomRadioButton
                              data={[
                                {
                                  value: 'appointmentType2',
                                  labelId: 'Initial',
                                  defaultLabel: 'Initial',
                                },
                                {
                                  value: 'appointmentType3',
                                  labelId: 'Follow up',
                                  defaultLabel: 'Follow up',
                                },
                              ]}
                              value={values.appointmentType}
                              disable={true}
                              onSelectItem={() => {}}
                              row={false}
                            />

                            {errors.appointmentType &&
                              touched.appointmentType && (
                                <SmallTypography
                                  sxProps={{ color: 'red' }}
                                  labelId={errors.appointmentType}
                                />
                              )}
                          </Grid>
                        </Grid>
                      )}

                      <Grid container direction="row" alignItems="center">
                        <Grid container direction="row" alignItems="center">
                          <Grid item xs={1} className="svgIcon">
                            <Calender />
                          </Grid>
                          <Grid item xs={11} className="multisearchHgt">
                            <DatePickerComponent
                              required
                              labelid="IFSP.Date"
                              defaultlabelid="Date *"
                              value={commonDate ? dayjs(commonDate) : null}
                              disabledDate={
                                schedulerEvent.allowUpdateDeleteActions ===
                                false
                              }
                              minDate={getMinimumDate()}
                              handlechange={(date: Dayjs | null) => {
                                if (date) {
                                  const formattedDate =
                                    dayjs(date).format('MM/DD/YYYY');
                                  setFieldValue('editDate', formattedDate);
                                  setCommonDate(formattedDate);
                                  setBackupSelectedCommonDate(formattedDate);
                                } else {
                                  setFieldValue('editDate', null);
                                  setBackupSelectedCommonDate(null);
                                  setCommonDate(null);
                                }
                              }}
                            />
                            {errors.editDate && touched.editDate && (
                              <SmallTypography
                                sxProps={{ color: 'red' }}
                                labelId={errors.editDate}
                              />
                            )}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container direction="row" alignItems="center">
                        <Grid container direction="row" alignItems="center">
                          <Grid item xs={1} className="svgIcon">
                            <User />
                          </Grid>
                          <Grid item xs={11} className="multisearchHgt">
                            <MultiSelectAutocompleteSearch
                              labelId="AddNewSchedulerEvent.clients"
                              defaultId="Add Client(s)"
                              disabled={getDisabledState(
                                values.appointmentType,
                                schedulerEvent.clients,
                              )}
                              disableClearable={true}
                              onTextChange={(
                                event: ChangeEvent<HTMLInputElement>,
                              ) => {
                                setClientSearchText(event.target.value.trim());
                              }}
                              onSelectItem={(
                                value: MultiSelectOptioinType[],
                              ) => {
                                setClientSearchText('');
                                let updatedSchedulerEvent = null;
                                const selectedClients =
                                  value.length > 0
                                    ? [value[value.length - 1]]
                                    : [];
                                if (
                                  !appointmentTypesForMultiClients.includes(
                                    values.appointmentType,
                                  )
                                ) {
                                  if (value.length == 0) {
                                    setFieldValue('clients', []);
                                    updatedSchedulerEvent = {
                                      ...schedulerEvent,
                                      clients: [],
                                    };
                                  } else if (value.length == 1) {
                                    setFieldValue(
                                      'clients',
                                      value.map((client) => client.clientId),
                                    );
                                    updatedSchedulerEvent = {
                                      ...schedulerEvent,
                                      clients: value as Client[],
                                    };
                                  } else {
                                    updatedSchedulerEvent = {
                                      ...schedulerEvent,
                                      clients: selectedClients as Client[],
                                    };
                                    setFieldValue(
                                      'clients',
                                      selectedClients.map(
                                        (client) => client.clientId,
                                      ),
                                    );
                                  }
                                } else {
                                  updatedSchedulerEvent = {
                                    ...schedulerEvent,
                                    clients: value as Client[],
                                  };
                                  setFieldValue(
                                    'clients',
                                    value.map((client) => client.clientId),
                                  );
                                }
                                if (
                                  values.appointmentType ===
                                    'appointmentType1' ||
                                  values.appointmentType ===
                                    'appointmentType2' ||
                                  values.appointmentType ===
                                    'appointmentType3' ||
                                  values.appointmentType ===
                                    'appointmentType4' ||
                                  values.appointmentType ===
                                    'appointmentType11' ||
                                  values.appointmentType === 'appointmentType5'
                                ) {
                                  let theSelectedClient: Client | null = null;
                                  if (selectedClients.length > 0) {
                                    theSelectedClient =
                                      selectedClients[0] as Client;
                                  }
                                  if (
                                    theSelectedClient !== null &&
                                    theSelectedClient.weapons === true &&
                                    theSelectedClient.weaponSecure === false
                                  ) {
                                    setFieldValue('location', '');
                                    setFieldValue(
                                      'description',
                                      'Weapons are not secure!',
                                    );
                                  } else if (selectedClients.length > 0) {
                                    const address = getClientAddress(
                                      selectedClients[0] as Client,
                                    );
                                    setFieldValue('location', address);
                                    setFieldValue('description', '');
                                    setOriginalAddress(address);
                                  } else if (value.length === 0) {
                                    setFieldValue('description', '');
                                    setFieldValue('location', '');
                                    setOriginalAddress(null);
                                  }
                                }
                                setSchedulerEvent(updatedSchedulerEvent);
                              }}
                              data={clients}
                              value={schedulerEvent.clients as Client[]}
                              optionHintId={
                                'AddNewSchedulerEvent.noClientsFoundInOptions'
                              }
                            />
                            {errors.clients && touched.clients && (
                              <SmallTypography
                                sxProps={{ color: 'red' }}
                                labelId={errors.clients as string}
                              />
                            )}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container direction="row" alignItems="center">
                        <Grid item xs={1} className="svgIcon">
                          <User />
                        </Grid>
                        <Grid item xs={11} className="multisearchHgt">
                          <MultiSelectAutocompleteSearch
                            labelId="AddNewSchedulerEvent.clinicians"
                            defaultId="Add Attendee(s)"
                            required
                            disableClearable={true}
                            onSelectItem={(value: MultiSelectOptioinType[]) => {
                              let attendees =
                                formRef.current?.values.attendeeList;
                              if (attendees) {
                                if (selectedAttendees.length > value.length) {
                                  const att = selectedAttendees.find(
                                    (attendee) => {
                                      return !value.some(
                                        (e) => attendee.id === e.id,
                                      );
                                    },
                                  );
                                  if (att) {
                                    let deleteItem = false;
                                    attendees.forEach((attendee) => {
                                      if (attendee.attendeeId === att.id) {
                                        if (attendee.status === 'CREATE') {
                                          deleteItem = true;
                                        } else {
                                          attendee.status = 'DELETE';
                                          attendee.startTime =
                                            attendee.startTime ?? attendee.date;
                                          attendee.endTime =
                                            attendee.endTime ??
                                            dayjs(attendee.date)
                                              .add(1, 'hour')
                                              .format();
                                          // attendee.interpreter = false;
                                          attendee.attendeeRole = AttendeeRole.CLINICIAN;
                                        }
                                      }
                                      return attendee;
                                    });
                                    if (deleteItem) {
                                      attendees = attendees.filter(
                                        (attendee) =>
                                          attendee.attendeeId !== att.id,
                                      );
                                    }
                                  }
                                } else {
                                  if (value.length === 0) {
                                    return;
                                  }
                                  const att = value.find((attendee) => {
                                    return !selectedAttendees.some(
                                      (e) => attendee.id === e.id,
                                    );
                                  });
                                  if (att) {
                                    let attendeeIndex = -1;
                                    attendees.forEach(
                                      (attendeeItem, attendeeItemIndex) => {
                                        if (
                                          attendeeItem.attendeeId === att.id
                                        ) {
                                          attendeeIndex = attendeeItemIndex;
                                        }
                                      },
                                    );
                                    if (attendeeIndex !== -1) {
                                      const existingAttendee =
                                        backupSchedulerEvent?.attendeeList.find(
                                          (attendee) =>
                                            attendee.attendeeId === att.id,
                                        );
                                      //This is when delete and add again the same attendee
                                      if (existingAttendee) {
                                        attendees[attendeeIndex].status =
                                          existingAttendee.status;
                                        attendees[attendeeIndex].attendeeRole =
                                          existingAttendee.attendeeRole;
                                       if (existingAttendee.attendeeRole !== AttendeeRole.CLINICIAN) {
  attendees.forEach((attendee) => {
    if (attendee.attendeeId !== existingAttendee.attendeeId) {
      attendee.attendeeRole = AttendeeRole.CLINICIAN;

      if (attendee.status !== 'CREATE') {
        attendee.status = 'NONE';
      }
    }
  });
}
                                      }
                                    } else {
                                      attendees.push({
                                        attendeeId: att.id as string,
                                        attendeeName: `${att.firstName} ${att.lastName}`,
                                        date: commonDate,
                                        startTime: appStartDate
                                          ? dayjs(appStartDate).format()
                                          : '',
                                        endTime: appStartDate
                                          ? dayjs(appStartDate)
                                              .add(1, 'hour')
                                              .format()
                                          : '',
                                        status: 'CREATE',
                                        appointmentId: '',
                                        allowUpdateDeleteActions: true,
                                        // interpreter: false,
                                        attendeeRole: AttendeeRole.CLINICIAN,
                                      });
                                    }
                                  }
                                }
                              } else {
                                attendees = [
                                  {
                                    attendeeId: value[0].id as string,
                                    attendeeName: `${value[0].firstName} ${value[0].lastName}`,
                                    date: commonDate,
                                    startTime: appStartDate
                                      ? dayjs(appStartDate).format()
                                      : '',
                                    endTime: appStartDate
                                      ? dayjs(appStartDate)
                                          .add(1, 'hour')
                                          .format()
                                      : '',
                                    status: 'CREATE',
                                    appointmentId: '',
                                    allowUpdateDeleteActions: true,
                                    // interpreter: false,
                                    attendeeRole: AttendeeRole.CLINICIAN,
                                  },
                                ];
                              }
                              selectedAttendees = value;
                              formRef.current?.setValues({
                                ...values,
                                attendees: value.map(
                                  (employee) => employee.id as string,
                                ),
                                attendeeList: attendees,
                              });
                            }}
                            highlightSelectedValues={
                              highlightUnavailableAttendees
                                ? unavailableAttendees
                                : []
                            }
                            highlightSelectedValuesTooltipLabelId="AddNewSchedulerEvent.unavailableAttendeesTooltip"
                            data={employees}
                            hideOption={null}
                            value={selectedAttendees}
                            optionHintId={
                              'AddNewSchedulerEvent.noCliniciansFoundInOptions'
                            }
                          />
                          {errors.attendees && touched.attendees && (
                            <SmallTypography
                              sxProps={{ color: 'red' }}
                              labelId={errors.attendees as string}
                            />
                          )}
                        </Grid>
                      </Grid>
                      {values.attendeeList &&
                        values.attendeeList.length > 0 &&
                        values.attendeeList.map((attendee, index) => {
                          if (attendee.status !== 'DELETE') {
                            return (
                              <Grid
                                container
                                xs={12}
                                key={attendee.attendeeId}
                                direction="row"
                                alignItems={'end'}
                                columnSpacing={'16px'}
                              >
                                <Grid item xs={1} className="svgIcon">
                                  <Clock />
                                </Grid>
                                <Grid item xs={4} className="hide">
                                  <MediumTypography
                                    sxProps={{ marginBottom: '4px' }}
                                    label={attendee.attendeeName}
                                  />
                                  <DatePickerComponent
                                    labelid="IFSP.Date"
                                    defaultlabelid="Date *"
                                    required={true}
                                    value={
                                      attendee.date !== null
                                        ? dayjs(attendee.date)
                                        : null
                                    }
                                    disabledDate={true}
                                    handlechange={(date: Dayjs | null) => {
                                      const formattedDate =
                                        dayjs(date).format('MM/DD/YYYY');
                                      setFieldValue(
                                        `attendeeList[${index}].date`,
                                        formattedDate,
                                      );
                                      if (
                                        values.attendeeList[index].status !==
                                        'CREATE'
                                      ) {
                                        setFieldValue(
                                          `attendeeList[${index}].status`,
                                          'UPDATE',
                                        );
                                      }
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <MediumTypography
                                    sxProps={{ marginBottom: '4px' }}
                                    label={attendee.attendeeName}
                                  />
                                  <AppTimePicker
                                    name="Start Time"
                                    value={
                                      values.attendeeList[index].startTime !==
                                      ''
                                        ? dayjs(
                                            values.attendeeList[index]
                                              .startTime,
                                          )
                                        : null
                                    }
                                    minuteStep={1}
                                    disable={
                                      !values.attendeeList[index]
                                        .allowUpdateDeleteActions
                                    }
                                    onTimeChange={(time) => {
                                      if (time === null) {
                                        values.attendeeList[index].startTime =
                                          '';
                                        values.attendeeList[index].endTime = '';
                                      } else {
                                        const date =
                                          dayjs(commonDate).format(
                                            'MM/DD/YYYY',
                                          ) +
                                          ' ' +
                                          dayjs(time).format('HH:mm.ss');
                                        values.attendeeList[index].startTime =
                                          dayjs(
                                            date,
                                            'MM/DD/YYYY HH:mm.ss',
                                          ).format();
                                        values.attendeeList[index].endTime = '';
                                      }

                                      if (
                                        values.attendeeList[index].status !==
                                        'CREATE'
                                      ) {
                                        values.attendeeList[index].status =
                                          'UPDATE';
                                      }
                                      formRef.current?.setValues(values);
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <AppTimePicker
                                    name="End Time"
                                    disable={
                                      !values.attendeeList[index]
                                        .allowUpdateDeleteActions
                                    }
                                    value={
                                      values.attendeeList[index].endTime !==
                                      null
                                        ? dayjs(
                                            values.attendeeList[index].endTime,
                                          )
                                        : null
                                    }
                                    minuteStep={1}
                                    onTimeChange={(time) => {
                                      if (time === null) {
                                        values.attendeeList[index].endTime = '';
                                      } else {
                                        const date =
                                          dayjs(commonDate).format(
                                            'MM/DD/YYYY',
                                          ) +
                                          ' ' +
                                          dayjs(time).format('HH:mm.ss');
                                        values.attendeeList[index].endTime =
                                          dayjs(
                                            date,
                                            'MM/DD/YYYY HH:mm.ss',
                                          ).format();
                                      }

                                      const initialIds = new Set(
                                        schedulerEventAttendeeList.map(
                                          (attendee2) => attendee2.attendeeId,
                                        ),
                                      );

                                      const updatingAttendee =
                                        values.attendeeList[index];
                                      const isExisting = initialIds.has(
                                        updatingAttendee.attendeeId,
                                      );
                                      if (
                                        updatingAttendee.status !== 'DELETE'
                                      ) {
                                        updatingAttendee.status = isExisting
                                          ? 'UPDATE'
                                          : 'CREATE';
                                      }

                                      formRef.current?.setValues(values);
                                    }}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                  display="flex"
                                  alignItems="center"
                                >
                                  <DropdownComponent
                                    labelid="assistantType"
                                    defaultlabelid="Assistant Type"
                                    names={InterpreterOptions}
                                    value={values.attendeeList[index].attendeeRole ?? AttendeeRole.CLINICIAN}
                                    handleChange={(value: string) => {
                                      

                                      // Check if there's a non-editable interpreter in backup
                                      const hasNoneditableInterpreter =
                                        backupSchedulerEvent?.attendeeList.some(
                                          (att) =>
                                            (att.attendeeRole === AttendeeRole.INTERPRETER || att.attendeeRole === AttendeeRole.GROUP_ASSISTANT) &&
                                            !att.allowUpdateDeleteActions,
                                        );


                                      if (
                                        hasNoneditableInterpreter &&
                                        !schedulerEvent.allowUpdateDeleteActions &&
                                        !values.attendeeList[index]
                                          .allowUpdateDeleteActions
                                      ) {
                                        return;
                                      }
                                      if (backupSchedulerEvent) {
                                        const originalAttendee =
                                          backupSchedulerEvent.attendeeList[index];
                                        const currentAttendee =
                                          values.attendeeList[index];

                                        if (originalAttendee) {
                                          if (originalAttendee.attendeeRole === AttendeeRole[value as keyof typeof AttendeeRole]) {
                                            currentAttendee.status = 'NONE';
                                          } else {
                                            currentAttendee.status = 'UPDATE';
                                          }
                                        }

                                        currentAttendee.attendeeRole = AttendeeRole[value as keyof typeof AttendeeRole];
                                        formRef.current?.setValues({ ...values });
                                      } else {
                                        values.attendeeList[index].attendeeRole = AttendeeRole[value as keyof typeof AttendeeRole];
                                        formRef.current?.setValues({ ...values });
                                      }


                                    }}
                                    disabled={
                                      !values.attendeeList[index].allowUpdateDeleteActions
                                    }
                                  />
</Grid>
                                 
                                
                                <Grid item xs={1.1}></Grid>
                                <Grid item xs={4}>
                                  {touched?.attendeeList &&
                                    (
                                      errors?.attendeeList as FormikErrors<SchedulerAttendee>[]
                                    )?.[index]?.startTime && (
                                      <MediumTypography
                                        labelid={
                                          (
                                            errors.attendeeList as FormikErrors<SchedulerAttendee>[]
                                          )[index].startTime
                                        }
                                        defaultlabel="Start or End time is required"
                                        className="errorText-md"
                                      />
                                    )}
                                </Grid>
                                <Grid item xs={4}>
                                  {touched?.attendeeList &&
                                    (
                                      errors?.attendeeList as FormikErrors<SchedulerAttendee>[]
                                    )?.[index]?.endTime && (
                                      <MediumTypography
                                        labelid={
                                          (
                                            errors.attendeeList as FormikErrors<SchedulerAttendee>[]
                                          )[index].endTime
                                        }
                                        defaultlabel="End date must be after start date"
                                        className="errorText-md"
                                      />
                                    )}
                                </Grid>
                              </Grid>
                            );
                          }
                        })}

                      <Grid container direction="row" alignItems="center">
                        <Grid item xs={1} className="svgIcon">
                          <MapPin />
                        </Grid>
                        <Grid item xs={11}>
                          <Textinput
                            name="location"
                            labelid="AddNewSchedulerEvent.location"
                            defaultlabelid="Add Location"
                            Value={values.location}
                            inputProps={{
                              maxLength: 300,
                            }}
                            Required={values.clients.length >= 1}
                            handlechange={(value: string) => {
                              setFieldValue('location', value);
                            }}
                            disabled={
                              schedulerEvent.allowUpdateDeleteActions === false
                            }
                          />

                          {errors.location && touched.location && (
                            <MediumTypography
                              labelid={errors.location}
                              className="errorText-md"
                            />
                          )}
                        </Grid>
                      </Grid>

                      <Grid container direction="row" alignItems="center">
                        <Grid item xs={1} className="svgIcon">
                          <AlignLeft />
                        </Grid>
                        <Grid item xs={11}>
                          <Textinput
                            name="description"
                            Value={values.description}
                            labelid="AddNewSchedulerEvent.notes"
                            defaultlabelid="Add Notes"
                            inputProps={{
                              maxLength: 500,
                            }}
                            handlechange={(value: string) => {
                              setFieldValue('description', value);
                            }}
                            disabled={
                              schedulerEvent.allowUpdateDeleteActions === false
                            }
                          />
                          {errors.description && touched.description && (
                            <MediumTypography
                              labelid={errors.description}
                              className="errorText-md"
                            />
                          )}
                        </Grid>
                      </Grid>

                      {loggedInClinicianName != undefined && (
                        <Grid container direction="row" alignItems="top">
                          <Grid item xs={1} className="svgIcon">
                            <Calender />
                          </Grid>
                          <Grid
                            item
                            xs={11}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              color: '#2A4241',
                              fontSize: '14px',
                              fontWeight: '400',
                              lineHeight: '18px',
                            }}
                          >
                            {prepareOwnerName()}
                          </Grid>
                        </Grid>
                      )}

                      <Grid
                        container
                        direction="row"
                        alignItems="right"
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Grid item sx={{ marginRight: '16px' }}>
                          <ButtonComponent
                            className="btn-primary btn-cancel"
                            variantType="contained"
                            labelId="AddNewSchedulerEvent.cancelButton"
                            defaultLabelId="Cancel"
                            onClick={() => {
                              if (_.isEqual(initialValues, values)) {
                                onModalClose(
                                  false,
                                  'success',
                                  undefined,
                                  undefined,
                                  undefined,
                                );
                              } else {
                                setOpenModal(true);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item>
                          <ButtonComponent
                            className="btn-primary btn-submit"
                            variantType="contained"
                            type="submit"
                            labelId="EditSchedulerEvent.submitButton"
                            defaultLabelId="Update"
                            onClick={handleSubmit}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Formik>
              </Card>
            </Box>
          </>
        )}
      </Drawer>
    </>
  );
};

export default EditSchedulerEventModal;
